import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { Typography } from '@raisin/components-lib';

export const FilterContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(7.5, 0, 0, 0),
  margin: theme.spacing(5, 0),

  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(7.5, 6, 0, 6),
  },
}));

export const TotalBanks = styled(Typography)(({ theme }) => ({
  color: theme.palette.black60.main,
}));
